import { render, staticRenderFns } from "./UserProfileModal.vue?vue&type=template&id=001f73c2&"
import script from "./UserProfileModal.vue?vue&type=script&lang=ts&"
export * from "./UserProfileModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports